import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  BalanceAdjustmentDeleteInput,
  BalanceAdjustmentModel,
  BalanceAdjustmentMutationInput,
  BalanceAdjustmentUpdateInput,
} from './model';

export function useCreateBalanceAdjustment(
  options?: UseMutationOptions<
    ApiResult<BalanceAdjustmentModel>,
    ApiError,
    BalanceAdjustmentMutationInput
  >,
): UseMutationResult<
  ApiResult<BalanceAdjustmentModel>,
  ApiError,
  BalanceAdjustmentMutationInput
> {
  return useMutation<
    ApiResult<BalanceAdjustmentModel>,
    ApiError,
    BalanceAdjustmentMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'balance-adjustments',
      method: 'POST',
      classType: BalanceAdjustmentModel,
      body,
    });
  }, options);
}

export function useUpdateBalanceAdjustment(
  options?: UseMutationOptions<
    ApiResult<BalanceAdjustmentModel>,
    ApiError,
    BalanceAdjustmentUpdateInput
  >,
): UseMutationResult<
  ApiResult<BalanceAdjustmentModel>,
  ApiError,
  BalanceAdjustmentUpdateInput
> {
  return useMutation<
    ApiResult<BalanceAdjustmentModel>,
    ApiError,
    BalanceAdjustmentUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `balance-adjustments/${body.balanceAdjustmentId}`,
      method: 'PUT',
      classType: BalanceAdjustmentModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteBalanceAdjustment(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    BalanceAdjustmentDeleteInput
  >,
): UseMutationResult<
  { message: string },
  ApiError,
  BalanceAdjustmentDeleteInput
> {
  return useMutation<
    { message: string },
    ApiError,
    BalanceAdjustmentDeleteInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `balance-adjustments/${body.balanceAdjustmentId}/void`,
      method: 'PATCH',
    });
  }, options);
}
